import React from 'react';
import { SelectableOption } from 'Interfaces/Common';
import { Signer } from 'Interfaces/Document';
import {
  DocumentField,
  DocumentFieldsCRUDMeta,
  DocumentFieldTypes,
  DocumentFieldUpdatePayload,
} from 'Interfaces/DocumentFields';

import FieldCheckedByDefault from './FieldCheckedByDefault';
import FieldParticipantsList from './FieldParticipantsList';
import FieldRequired from './FieldRequired';
import FieldStyleSelectors from './FieldStyleSelectors';

interface FieldItemMenuProps {
  field: DocumentField;
  signer: Signer;
  signersOptions: SelectableOption<string>[];
  onChangeSigner: (signerId: string) => void;
  onUpdateDocumentField: (
    payload: Omit<DocumentFieldUpdatePayload, 'id'>,
    meta?: DocumentFieldsCRUDMeta,
  ) => void;
}

function FieldItemMenu({
  field,
  signer,
  signersOptions,
  onChangeSigner,
  onUpdateDocumentField,
}: FieldItemMenuProps) {
  const { type, required, fontFamily, checked, signerId } = field;

  switch (type) {
    case DocumentFieldTypes.Signature:
    case DocumentFieldTypes.Initials: {
      return (
        <div className="fieldDropDown__content-body">
          <FieldParticipantsList
            isCheckable
            field={field}
            signerId={signerId}
            signersOptions={signersOptions}
            onUpdateDocumentField={onUpdateDocumentField}
            onChangeSigner={onChangeSigner}
          />
          <FieldRequired
            isChecked={required}
            onUpdateDocumentField={onUpdateDocumentField}
          />
        </div>
      );
    }
    case DocumentFieldTypes.Checkbox: {
      return (
        <div className="fieldDropDown__content-body">
          <FieldParticipantsList
            isCheckable
            field={field}
            signerId={signerId}
            signersOptions={signersOptions}
            onUpdateDocumentField={onUpdateDocumentField}
            onChangeSigner={onChangeSigner}
          />
          <FieldRequired
            isChecked={required}
            onUpdateDocumentField={onUpdateDocumentField}
          />
          {!signer?.isPreparer && (
            <FieldCheckedByDefault
              isChecked={!!checked}
              onUpdateDocumentField={onUpdateDocumentField}
            />
          )}
        </div>
      );
    }
    case DocumentFieldTypes.Name: {
      return (
        <div className="fieldDropDown__content-body">
          <FieldParticipantsList
            isCheckable
            field={field}
            signerId={signerId}
            signersOptions={signersOptions}
            onUpdateDocumentField={onUpdateDocumentField}
            onChangeSigner={onChangeSigner}
          />
          <FieldStyleSelectors
            fontFamily={fontFamily}
            onUpdateDocumentField={onUpdateDocumentField}
          />
        </div>
      );
    }
    case DocumentFieldTypes.Date:
    case DocumentFieldTypes.Text: {
      return (
        <div className="fieldDropDown__content-body">
          <FieldParticipantsList
            isCheckable
            field={field}
            signerId={signerId}
            signersOptions={signersOptions}
            onUpdateDocumentField={onUpdateDocumentField}
            onChangeSigner={onChangeSigner}
          />
          <FieldStyleSelectors
            fontFamily={fontFamily}
            onUpdateDocumentField={onUpdateDocumentField}
          />
          <FieldRequired
            isChecked={required}
            onUpdateDocumentField={onUpdateDocumentField}
          />
        </div>
      );
    }
    default: {
      return null;
    }
  }
}

export default FieldItemMenu;
